import { FC } from 'react';
import styles from './index.module.less';
import KeyMetrics from './KeyMetrics';
import EntryRate from './EntryRate';
import SpotFlow from './SpotFlow';
import Surround from './Surround';

/**
 * 分析完成结果
 * @description
 * @demo
 */
const Component:FC<{
  reload?: () => void;
}> = ({ reload }) => {

  /* state */

  /* hooks */

  /* methods */

  return (<div className={styles.result}>

    <KeyMetrics reload={reload}/>

    <EntryRate />

    <SpotFlow />

    <Surround />

  </div>);
};

export default Component;
